module.exports = __webpack_public_path__ + "img/profile.74aa3707.svg";